var GCValidators = (function () {
    function GCValidators() {
    }
    GCValidators.minValue = function (minValue) {
        return function (control) {
            var value = control.value;
            return (value >= minValue) ? null : {
                validateNumber: {
                    valid: false,
                    errorMessage: 'Zahl muss größer als ' + minValue + ' sein',
                },
            };
        };
    };
    GCValidators.maxValue = function (maxValue) {
        return function (control) {
            var value = control.value;
            return (value <= maxValue) ? null : {
                validateNumber: {
                    valid: false,
                    errorMessage: 'Zahl muss kleiner als ' + maxValue + ' sein',
                },
            };
        };
    };
    GCValidators.minLength = function (minLength) {
        return function (control) {
            var value = control.value;
            var valueLength = String(value).length;
            return (valueLength >= minLength) ? null : {
                validateNumber: {
                    valid: false,
                    errorMessage: 'Zahl muss mindestens ' + minLength + ' Stellen haben',
                },
            };
        };
    };
    GCValidators.maxLength = function (maxLength) {
        return function (control) {
            var value = control.value;
            var valueLength = String(value).length;
            return (valueLength <= maxLength) ? null : {
                validateNumber: {
                    valid: false,
                    errorMessage: 'Zahl darf maximal ' + maxLength + ' Stellen haben',
                },
            };
        };
    };
    GCValidators.validateEmail = function () {
        return function (control) {
            var value = control.value;
            /* tslint:disable */
            var EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            /* tslint:enable */
            return (value.length > 0) ? EMAIL_REGEXP.test(value) ? null : {
                validateEmail: {
                    valid: false,
                    error: 'Bitte korrekte E-Mail-Adresse angeben',
                },
            } : null;
        };
    };
    GCValidators.validateTime = function () {
        return function (control) {
            var value = control.value;
            /* tslint:disable */
            var TIME_REGEXP = /^([0-9]|0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]$/;
            /* tslint:enable */
            return (value.length === 0) || !TIME_REGEXP.test(value) ? {
                validateTime: {
                    valid: false,
                    error: 'Bitte korrekte Zeit angeben',
                },
            } : null;
        };
    };
    GCValidators.validatePassword = function () {
        return function (control) {
            var value = control.value;
            var minLowerCase = 1;
            var minUpperCase = 1;
            var minDecimals = 1;
            var minSpecialChars = 0;
            var minChars = Math.max(8, (minLowerCase + minUpperCase + minDecimals + minSpecialChars));
            var PASSWORD_REGEXP = new RegExp('(?=.*\\d)(?=.*[a-z]{' + minLowerCase + ',})' +
                '(?=.*[A-Z]{' + minUpperCase + ',})' +
                '(?=.*[0-9]{' + minDecimals + ',})' +
                '(?=(.*\\W){' + minSpecialChars + '})' +
                '.{' + minChars + ',}');
            return PASSWORD_REGEXP.test(value) ? null : {
                validatePassword: {
                    valid: false,
                    errorMessage: 'Ihr Passwort sollte min. 8 Zeichen lang sein und einen Groß- und Kleinbuchstaben und eine Zahl enthalten.',
                },
            };
        };
    };
    GCValidators.validatePasswordComparison = function () {
        return function (control) {
            var value = control.value;
            return (control.parent) ? (control.parent.controls['password'].value === value) ? null : {
                validatePasswordComparison: {
                    valid: false,
                    errorMessage: 'Passwörter stimmen nicht überein',
                },
            } : null;
        };
    };
    GCValidators.validatePhone = function () {
        return function (control) {
            var value = control.value;
            var PHONE_REGEXP = /^(?=.*[0-9]).{5}$/;
            return (value.length > 0) ? PHONE_REGEXP.test(value) ? null : {
                validatePhone: {
                    valid: false,
                    errorMessage: 'Keine korrekte Telefonnummer',
                },
            } : null;
        };
    };
    return GCValidators;
}());
export { GCValidators };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/validators/gc-validator.ts.pre-build-optimizer.js